module.exports = __webpack_public_path__ + "static/media/medidor.f5cd69d1.png";